import { useState, useEffect } from "react";
import { ALTIN, INK, INK_2, KAGIT, CIZGI, DISPLAY, GOVDE, CIKIS, BLOK } from "../data/constants";

/* =============================================================
   ÜST MENÜ

   Eski menü koyu bir kahraman görselinin üstünde duruyordu: yazılar
   beyazdı ve yalnız sayfa kaydırılınca okunur hale geliyordu. Yeni
   tasarımda kahraman AÇIK zeminde, o yüzden menü baştan koyu yazılı.

   Mobilde açılır menü artık gerçek bir düğmeyle yönetiliyor
   (aria-expanded + aria-controls), Escape ile kapanıyor ve menü
   açıkken arkadaki sayfa kaymıyor.
   ============================================================= */

const MENU = [
  ["Hizmetler", "services", "/hizmetler"],
  ["Blog", "blog", "/blog"],
  ["Hakkımızda", "about", "/hakkimizda"],
  ["İletişim", "contact", "/iletisim"],
];

export default function NavBar({ onNavigate, currentPage }) {
  const [menuAcik, setMenuAcik] = useState(false);
  const [dar, setDar] = useState(false);

  useEffect(() => {
    const olc = () => setDar(window.innerWidth <= 860);
    olc();
    window.addEventListener("resize", olc);
    return () => window.removeEventListener("resize", olc);
  }, []);

  // Menü açıkken arkadaki sayfa kaymasın, Escape kapatsın.
  useEffect(() => {
    if (!menuAcik) return;
    const eskiTasma = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const tus = (e) => { if (e.key === "Escape") setMenuAcik(false); };
    window.addEventListener("keydown", tus);
    return () => {
      document.body.style.overflow = eskiTasma;
      window.removeEventListener("keydown", tus);
    };
  }, [menuAcik]);

  const git = (p) => { onNavigate(p); setMenuAcik(false); };

  const bag = (secili) => ({
    fontFamily: GOVDE,
    fontSize: 14.5,
    fontWeight: secili ? 600 : 500,
    color: secili ? INK : INK_2,
    padding: "4px 0",
    transition: `color .18s ${CIKIS}`,
    borderBottom: secili ? `2px solid ${ALTIN}` : "2px solid transparent",
  });

  return (
    <><header style={{
        position: "sticky", top: 0, zIndex: 1000,
        background: "rgba(251,250,246,0.92)",
        backdropFilter: "blur(12px)",
        borderBottom: `1px solid ${CIZGI}`,
      }}><div style={{
          maxWidth: 1200, margin: "0 auto", padding: "0 30px",
          height: 70, display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 22,
        }}><a href="/" onClick={(e) => { e.preventDefault(); git("home"); }}
             aria-label="Whayns Dijital ana sayfa"style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: 19,
                      letterSpacing: "-0.04em", color: INK, flexShrink: 0 }}>
            WHAYNS<span style={{ color: ALTIN }}>.</span></a>

          {!dar && (
            <nav aria-label="Ana menü" style={{ display: "flex", gap: 28, alignItems: "center" }}>
              {MENU.map(([et, p, href]) => (
                <a key={p} href={href}
                   onClick={(e) => { e.preventDefault(); git(p); }}
                   aria-current={currentPage === p ? "page" : undefined}
                   style={bag(currentPage === p)}
                   onMouseEnter={(e) => { e.currentTarget.style.color = INK; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = currentPage === p ? INK : INK_2; }}
                >{et}</a>
              ))}
            </nav>
          )}

          {!dar ? (
            <a href="/iletisim" onClick={(e) => { e.preventDefault(); git("contact"); }}
               style={{
                 background: BLOK, color: KAGIT, padding: "12px 20px",
                 borderRadius: 10, fontFamily: DISPLAY, fontWeight: 600, fontSize: 14.5,
                 transition: `background .18s ${CIKIS}`, flexShrink: 0,
               }}
               onMouseEnter={(e) => { e.currentTarget.style.background = "#000"; }}
               onMouseLeave={(e) => { e.currentTarget.style.background = INK; }}
            >Ücretsiz analiz</a>
          ) : (
            <button
              onClick={() => setMenuAcik((v) => !v)}
              aria-expanded={menuAcik}
              aria-controls="mobil-menu"aria-label={menuAcik ? "Menüyü kapat" : "Menüyü aç"}
              style={{
                background: "none", border: 0, cursor: "pointer", padding: 10,
                display: "flex", flexDirection: "column", gap: 5, flexShrink: 0,
              }}
            >
              {[0, 1, 2].map((i) => (
                <span key={i} style={{
                  display: "block", width: 24, height: 2, borderRadius: 2, background: BLOK,
                  transition: `transform .28s ${CIKIS}, opacity .2s ${CIKIS}`,
                  transform: menuAcik
                    ? (i === 0 ? "translateY(7px) rotate(45deg)": i === 2 ? "translateY(-7px) rotate(-45deg)" : "none")
                    : "none",
                  opacity: menuAcik && i === 1 ? 0 : 1,
                }} />
              ))}
            </button>
          )}
        </div></header>

      {dar && (
        <div id="mobil-menu" hidden={!menuAcik} style={{
          position: "fixed", top: 70, left: 0, right: 0, bottom: 0, zIndex: 999,
          background: KAGIT, padding: "10px 20px 30px", overflowY: "auto",
        }}>
          {[["Ana sayfa", "home", "/"], ...MENU].map(([et, p, href]) => (
            <a key={p} href={href}
               onClick={(e) => { e.preventDefault(); git(p); }}
               aria-current={currentPage === p ? "page" : undefined}
               style={{
                 display: "block", fontFamily: DISPLAY, fontSize: 19, fontWeight: 600,
                 color: currentPage === p ? ALTIN : INK,
                 padding: "18px 0", borderBottom: `1px solid ${CIZGI}`,
               }}
            >{et}</a>
          ))}
          <a href="/iletisim" onClick={(e) => { e.preventDefault(); git("contact"); }}
             style={{
               display: "block", marginTop: 24, background: BLOK, color: KAGIT,
               padding: "16px 22px", borderRadius: 10, textAlign: "center",
               fontFamily: DISPLAY, fontWeight: 600, fontSize: 16,
             }}
          >Ücretsiz analiz al</a></div>
      )}
    </>
  );
}
